import PropTypes from "prop-types";
import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { Col, FormGroup, Label } from "reactstrap";
import { SingleDatePicker } from "react-dates";
// import TimePicker from "./TimePicker";
import "react-dates/initialize";
import "../../../scss/date.css";

const DateTimePicker = ({
  t,
  handleDateStart,
  handleDateEnd,
  // handleTimeChange,
  time,
}) => {
  const [dateStartFocused, setDateStartFocused] = useState(false);
  const [dateEndFocused, setDateEndFocused] = useState(false);

  return (
    <div style={{ marginTop: 10 }} role='date-time-picker'>
      <FormGroup row>
        <Col xs="6" md="2">
          <Label className="label-date">{t("DateTimePicker.from")}</Label>
        </Col>
        <Col xs="6" md="6">
          <SingleDatePicker
            date={time.dateStart}
            onDateChange={(date) => handleDateStart(date)}
            focused={dateStartFocused}
            onFocusChange={(focus) => setDateStartFocused(focus.focused)}
            id="date_start_input"
            displayFormat="DD/MM/YYYY"
            small
            numberOfMonths={1}
            hideKeyboardShortcutsPanel
            isOutsideRange={() => false}
            placeholder=""
          />
        </Col>
        {/* <Col xs="6" md="3">
          <TimePicker id="timeStart" name="timeStart" value={time.timeStart} onChange={(event) => handleTimeChange(event)} />
        </Col> */}
      </FormGroup>
      <FormGroup row>
        <Col xs="6" md="2">
          <Label className="label-date">{t("DateTimePicker.to")}</Label>
        </Col>
        <Col xs="6" md="6">
          <SingleDatePicker
            date={time.dateEnd}
            onDateChange={(date) => handleDateEnd(date)}
            focused={dateEndFocused}
            onFocusChange={(focus) => setDateEndFocused(focus.focused)}
            id="date_end_input"
            displayFormat="DD/MM/YYYY"
            small
            numberOfMonths={1}
            hideKeyboardShortcutsPanel
            isOutsideRange={() => false}
            placeholder=""
          />
        </Col>
        {/* <Col xs="6" md="3">
          <TimePicker
            id="timeEnd"
            name="timeEnd"
            value={time.timeEnd}
            onChange={(event) => handleTimeChange(event)}
          />
        </Col> */}
      </FormGroup>
    </div>
  );
};

DateTimePicker.propTypes = {
  handleDateEnd: PropTypes.func,
  handleDateStart: PropTypes.func,
  // handleTimeChange: PropTypes.func,
  t: PropTypes.func,
  time: PropTypes.object,
};

export default withTranslation()(DateTimePicker);
